import { useEffect, useRef } from 'react';

import { sendPartial } from './submit-lead';

/**
 * Progressive capture: while the visitor types, send the current form values
 * to the API (debounced) so contact details reach the server before Send is
 * ever tapped. Renders nothing. Mount inside the Formik <Form>.
 */
export default function PartialCapture({ values, page }) {
  const timer = useRef(null);
  const snapshot = JSON.stringify([
    values.fullName,
    values.email,
    values.phoneNumber,
    values.postalCodeValue,
    values.city,
    values.windowsReplace,
    values.windowsAge,
    values.next90days,
  ]);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      sendPartial(values, page);
    }, 1500);
    return () => clearTimeout(timer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [snapshot, page]);

  return null;
}
